import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// import { mapToCssModules, tagPropType } from .'/utils';
import { mapToCssModules, tagPropType } from "reactstrap/src/utils";

const propTypes = {
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object,
};

const defaultProps = {
  tag: 'a'
};

const NavbarBrandCreate = (props) => {
  const {
    className,
    cssModule,
    tag: Tag,
    ...attributes
  } = props;

  const classes = mapToCssModules(classNames(
    className,
    'Navbar-brand-create'
  ), cssModule);

  return (
    <Tag {...attributes} className={classes} />
  );
};

NavbarBrandCreate.propTypes = propTypes;
NavbarBrandCreate.defaultProps = defaultProps;

export default NavbarBrandCreate;
